import { render } from "./TheMessage.vue?vue&type=template&id=d620025c"
import script from "./TheMessage.vue?vue&type=script&lang=js"
export * from "./TheMessage.vue?vue&type=script&lang=js"

import "./TheMessage.vue?vue&type=style&index=0&id=d620025c&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__